import { setElementBelow, showElementInView } from './reveal_state'
import { isRevealAnimationDisabled, shouldAnimateElement } from './element_animate_in_on_scroll_helpers'

const buildIsInCurrentSection = function (obj, fallbackIndex) {
	if (obj && Array.isArray(obj.visibleSections) && obj.visibleSections.length > 0) {
		return function (el) {
			return obj.visibleSections.some(function (section) {
				return section && section.contains && section.contains(el)
			})
		}
	}
	if (obj && obj.section) {
		return function (el) {
			return obj.section.contains(el)
		}
	}
	return function (el) {
		return !!el.closest('.row-' + fallbackIndex)
	}
}

const getItemsForFullpageEvent = function (obj, getItemsProjectOverlay, getItemsNormalPage, isProjectOverlayOpen) {
	var section = obj && obj.section
	if (!section && obj && Array.isArray(obj.visibleSections) && obj.visibleSections.length > 0) {
		section = obj.visibleSections[0]
	}
	if (section && section.closest) {
		if (section.closest('#lay-project-overlay')) {
			return getItemsProjectOverlay()
		}
		if (section.closest('body > .lay-content')) {
			return getItemsNormalPage()
		}
	}
	if (isProjectOverlayOpen()) {
		return getItemsProjectOverlay()
	}
	return getItemsNormalPage()
}

export const bindFullpageRevealHandlers = function (options) {
	const updateRevealStateForFullpageEvent = function (obj, fallbackIndex) {
		if (options.isOverlayClosing()) return

		var itemsForEvent = getItemsForFullpageEvent(
			obj,
			options.getItemsProjectOverlay,
			options.getItemsNormalPage,
			options.isProjectOverlayOpen
		)
		if (!itemsForEvent || itemsForEvent.length === 0) {
			return
		}

		var isInCurrentSection = buildIsInCurrentSection(obj, fallbackIndex)

		itemsForEvent.forEach((element) => {
			if (!isRevealAnimationDisabled(element)) {
				if (element.closest('.lay-row-fixed')) {
					showElementInView(element)
					return
				}
				if (!shouldAnimateElement(element)) {
					return
				}

				if (isInCurrentSection(element)) {
					showElementInView(element)
				} else {
					setElementBelow(element)
				}
			}
		})
	}

	jQuery(window).on('fpAfterLoad', function (event, obj) {
		updateRevealStateForFullpageEvent(obj, obj.index - 1)
	})

	jQuery(window).on('fpAfterSlideLoad', function (event, obj) {
		updateRevealStateForFullpageEvent(obj, obj.slideIndex)
	})
}

var snapBoundContainers = new WeakSet()
var isRevealSnapTarget = function (target) {
	if (!target || !target.classList) {
		return false
	}

	return target.classList.contains('row') || target.classList.contains('lay-scrollsnap-footer-section')
}

export const bindScrollSnapRevealHandlers = function (options) {
	if (!('onscrollsnapchanging' in document.body) && !('onscrollsnapchange' in document.body)) {
		return
	}
	var containers = document.querySelectorAll('.vertical-scrollsnap, .horizontal-scrollsnap, .lay-scrollsnap-footer-scroll-container')
	containers.forEach(function (container) {
		if (snapBoundContainers.has(container)) return
		snapBoundContainers.add(container)
		var revealTarget = function (e) {
			var items = options.getItems()
			if (options.isOverlayClosing() || !items) return
			var targetRow = e && (e.snapTargetBlock || e.snapTargetInline)
			if (!isRevealSnapTarget(targetRow)) return
			items.forEach(function (el) {
				if (isRevealAnimationDisabled(el)) return
				if (!targetRow.contains(el)) return
				if (!shouldAnimateElement(el)) return
				el.style.transitionDelay = ''
				showElementInView(el)
			})
		}
		container.addEventListener('scrollsnapchanging', revealTarget)
		container.addEventListener('scrollsnapchange', revealTarget)
	})
}
